module.exports = __webpack_public_path__ + "static/media/bg2.28a3b5d8.jpg";